import styled from 'styled-components';
import { breakpoints } from 'definitions';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.8rem;
	padding-bottom: 2rem;
`;

export const Header = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
	justify-content: space-between;
	gap: 1.6rem;

	${breakpoints.phablet} {
		flex-direction: column;
		gap: 0.4rem;
	}
`;

export const TitleContainer = styled.div`
	display: flex;
	flex-direction: row;
	min-width: 0;

	${breakpoints.phablet} {
		justify-content: space-between;
	}
`;
